<template>
  <div>
    <placeholder
      v-if="!exam.candidate && !error.serverError"
      title="Loading exam info..."
    ></placeholder>
    <div class="row" v-else>
      <div class="col-4">
        <h6 class="font-light">Candidate Details</h6>
        <table class="table bordered">
          <tbody>
            <tr>
              <th>
                Name
              </th>
              <td>
                {{ exam.candidate.full_name }}
              </td>
            </tr>
            <tr>
              <th>
                ARN
              </th>
              <td>
                {{ exam.candidate.arn }}
              </td>
            </tr>
            <tr>
              <th>
                Signature
              </th>
              <td>
                <signature-status
                  class="u-center"
                  v-bind:signature="exam.candidate_signature"
                  v-bind:role="'candidate'"
                  v-bind:module="'exams'"
                  v-bind:dt="exam.candidate_signature_dt"
                >
                </signature-status>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-4">
        <h6 class="font-light">Supervisor</h6>
        <table class="table bordered">
          <tbody>
            <tr>
              <th>
                Name
              </th>
              <td>
                {{ exam.supervisor.full_name }}
              </td>
            </tr>
            <tr>
              <th>
                ARN
              </th>
              <td>
                {{ exam.supervisor.arn }}
              </td>
            </tr>
            <tr>
              <th>
                Signature
              </th>
              <td>
                <signature-status
                  class="u-center"
                  v-bind:signature="exam.supervisor_signature"
                  v-bind:role="'supervisor'"
                  v-bind:module="'exams'"
                  v-bind:dt="exam.supervisor_signature_dt"
                >
                </signature-status>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-4">
        <h6 class="font-light">Result</h6>
        <table class="table bordered">
          <tbody>
            <tr>
              <th>
                Result
              </th>
              <td>
                <status-tag
                  v-bind:status="exam.result.status"
                  v-bind:label="exam.result.name"
                >
                </status-tag>
              </td>
            </tr>
            <tr>
              <th>
                Marks
              </th>
              <td>
                <span v-if="exam.result.status >= 0">
                  {{ formatMarks(exam.marks_awarded) }} out of
                  {{ exam.marks_available }}
                  <strong>({{ getPercentageMark }})</strong>
                </span>
                <span v-else>N/A</span>
              </td>
            </tr>
            <tr>
              <th>
                Date
              </th>
              <td>
                <span v-if="exam.result.status >= 0">
                  {{ formatDate(exam.date) }}
                </span>
                <span v-else>N/A</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Placeholder from "@/components/Placeholder";
import { DateFormatter } from "@/functions/dateFormat.function";
import StatusTag from "@/components/StatusTag";
import SignatureStatus from "@/components/SignatureStatus";

export default {
  name: "exam-info",
  props: {
    exam: {}
  },
  components: {
    Placeholder,
    StatusTag,
    SignatureStatus
  },
  computed: {
    ...mapGetters("core", ["error"]),
    getPercentageMark() {
      var result = (this.exam.marks_awarded / this.exam.marks_available) * 100;
      if (Number.parseInt(result) != result) {
        result = Number.parseFloat(result).toFixed(1);
      }
      if (result > 1000) {
        return "0 %";
      } else {
        return result + " %";
      }
    }
  },
  methods: {
    formatDate: function(dateString) {
      return DateFormatter(dateString);
    },
    formatMarks: function(marks) {
      var precision = Number;
      if (Number.parseInt(marks) == marks) {
        precision = 0;
      } else {
        precision = 1;
      }
      return Number.parseFloat(marks).toFixed(precision);
    }
  }
};
</script>
